import { Block } from 'baseui/block'
import { SIZE, StyledDivider } from 'baseui/divider'
import { Heading, HeadingLevel } from 'baseui/heading'
import React from 'react'
import styles from './Section.module.css'

export const Section = ({
    title,
    children,
    headingLevel = 6
}: {
    title?: string
    children: React.ReactNode
    headingLevel: 1 | 2 | 3 | 4 | 5 | 6
}) => {
    return (
        <div className={styles.root}>
            <HeadingLevel>
                <Heading styleLevel={headingLevel}>{title}</Heading>
                <StyledDivider $size={SIZE.cell} />
                <Block>{children}</Block>
            </HeadingLevel>
        </div>
    )
}
